import React from 'react';
import { Select } from '../../components/Select';
import { MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function LanguageSelector(props) {
	const { i18n } = useTranslation();
	return <Select
		value={i18n.language}
		{...props}
		onChange={e => {
			i18n.changeLanguage(e.target.value);
		}}
	>
		<MenuItem value="de"><span><i className="flag-icon flag-icon-de" /></span></MenuItem>
		<MenuItem value="en"><span><i className="flag-icon flag-icon-gb" /></span></MenuItem>
		<MenuItem value="fr"><span><i className="flag-icon flag-icon-fr" /></span></MenuItem>
		<MenuItem value="nl"><span><i className="flag-icon flag-icon-nl" /></span></MenuItem>
	</Select>;
}
